import { render, staticRenderFns } from "./TipWriter.vue?vue&type=template&id=275e81aa&"
import script from "./TipWriter.vue?vue&type=script&lang=js&"
export * from "./TipWriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports